export const  CITIES_REQUESTED = 'cities/CITIES_REQUESTED'
export const  FETCH_CITIES_REQUESTED   =    'cities/FETCH_CITIES_REQUESTED'
export const  FETCH_CITIES_SUCCEED   =      'cities/FETCH_CITIES_SUCCEED'
export const  FETCH_CITIES_FAIL     =       'cities/FETCH_CITIES_FAIL'



// WEBPACK FOOTER //
// ./src/store/cities/actionTypes.js